import { apiClient } from './apiClient';

export interface License {
  skuId: string;
  skuPartNumber: string;
  servicePlans: ServicePlan[];
  prepaidUnits: {
    enabled: number;
    suspended: number;
    warning: number;
  };
  consumedUnits: number;
}

export interface ServicePlan {
  servicePlanId: string;
  servicePlanName: string;
  provisioningStatus: string;
  appliesTo: string;
}

export interface UserLicense {
  skuId: string;
  skuPartNumber: string;
  disabledPlans: string[];
}

export interface AssignLicenseRequest {
  addLicenses: {
    skuId: string;
    disabledPlans?: string[];
  }[];
  removeLicenses: string[];
}

export interface LicensesListResponse {
  success: boolean;
  data: {
    value: License[];
  };
}

export interface UserLicensesResponse {
  success: boolean;
  data: {
    value: UserLicense[];
  };
}

export const licenseService = {
  async getLicenses(): Promise<LicensesListResponse> {
    return apiClient.get<LicensesListResponse>('/licenses');
  },

  async getUserLicenses(userId: string): Promise<UserLicensesResponse> {
    return apiClient.get<UserLicensesResponse>(`/users/${userId}/licenses`);
  },

  async assignLicense(userId: string, request: AssignLicenseRequest): Promise<void> {
    return apiClient.post(`/users/${userId}/assign-license`, request);
  },

  async removeLicense(userId: string, skuId: string): Promise<void> {
    return apiClient.post(`/users/${userId}/assign-license`, {
      addLicenses: [],
      removeLicenses: [skuId],
    });
  },
};
